import { withLoading, getExpiringLocalStorage } from '@front-activerse/common-components';
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import UniversalPlaceholder from '../../Layout/UniversalPlaceholder';
import {
  ONBOARDING_STORAGE_KEY,
  decodeOnboardingData,
  mapOnboardingToSaveVariables,
} from '../Onboarding/onboardingFromUrl';

const SavePaymentContainer = ({
  savePayment,
  userData,
  shoppingCartToken,
  pathPaymentMethods,
  saveOnboardingSettings,
}) => {
  const navigate = useNavigate();
  const hasRunRef = useRef(false);

  const saveOnboardingIfPresent = async () => {
    const encoded = localStorage.getItem(ONBOARDING_STORAGE_KEY);

    if (!encoded) return;
    const decoded = decodeOnboardingData(encoded);
    if (!decoded) return;
    const variables = mapOnboardingToSaveVariables(decoded);
    try {
      await saveOnboardingSettings(variables);
      localStorage.removeItem(ONBOARDING_STORAGE_KEY);
    } catch (error) {
      console.error('Failed to save onboarding settings', error);
    }
  };

  const handleSavePayment = async () => {
    await saveOnboardingIfPresent();

    const request = {
      productId: +localStorage.getItem('shopppingCartProductId'),
      source: getExpiringLocalStorage('saleSource'),
      saleShoppingId: 1,
      shoppingCartToken,
      email: userData.email,
      promoCode: getExpiringLocalStorage('promoCode'),
    };

    const response = await savePayment(request);

    if (response.data.sale.savePayment.__typename === 'Payment') {
      const paymentToken = response.data.sale.savePayment.token;
      navigate(pathPaymentMethods.replace(':token', paymentToken));
    }
  };

  useEffect(() => {
    if (hasRunRef.current) return;
    hasRunRef.current = true;
    handleSavePayment();
  }, []);
  return null;
};
const Placeholder = () => <UniversalPlaceholder simpleLayout fullHeightMinusHeader />;

export default withLoading(SavePaymentContainer, Placeholder);
